module.exports = {"150221104":"萨拉齐镇","150221105":"双龙镇","150221106":"美岱召镇","150221107":"沟门镇","150221108":"将军尧镇","150221213":"海子乡","150221214":"明沙淖乡","150221215":"苏波盖乡","150221500":"九峰山生态管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150221.json
// module id = 408
// module chunks = 0